import { Link } from '@backstage/core-components';
import {
  Card,
  CardContent,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { PdsButton } from '@principal/design-system-react';

import { useNavigate } from 'react-router-dom';

const cardData = [
  {
    title: 'First day and beyond',
    links: [
      {
        resourceName: 'Fundamentals checklist',
        description: 'Engineer expectations at a glance.',
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/principal/fundamentals',
      },
      {
        resourceName: 'Enterprise standard tools',
        description: 'Stay up-to-date on approved technologies.',
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/principal/tools',
      },
      {
        resourceName: 'Accounts and access',
        description: 'Get connected to the tools you need.',
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/principal/access',
      },
    ],
  },
  {
    title: 'Development',
    links: [
      {
        resourceName: 'Application patterns',
        description:
          'Accelerate development with reusable enterprise software.',
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/principal/innersource/patterns',
      },
      {
        resourceName: 'Cataloging components',
        description: 'Get your repository into PDP.',
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/principal/pdp/components',
      },
      {
        resourceName: 'Developer network (devnet)',
        description: 'Set yourself up for access anywhere.',
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/development/workstation/devnet/',
      },
    ],
  },
  {
    title: 'Engineering documentation',
    links: [
      {
        resourceName: 'Where should my documentation go?',
        description:
          'Learn how to choose between engineering documentation platforms.',

        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/principal/how-we-work/agile/documentation/',
      },
      {
        resourceName: 'Handbook Changelog',
        description: "See what's new in the Handbook, updated monthly.",
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/about/changelog',
      },
      {
        resourceName: 'Contributing to the Handbook',
        description: 'Info and guidelines on Handbook contribution.',
        uri: '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/about/contributing',
      },
    ],
  },
];

export function AdditionalContent() {
  const navigate = useNavigate();
  const handleOnClick = () =>
    navigate(
      '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook',
    );
  const theme = useTheme();
  return (
    <div
      style={{
        backgroundColor: '#002855',
        width: '100%',
        padding: '60px',
      }}
    >
      <Typography
        gutterBottom
        variant="h3"
        style={{
          color: 'white',
          padding: '20px 0px 30px 0px',
        }}
      >
        Picks from the Engineering Handbook
      </Typography>

      <Grid container spacing={3}>
        {cardData.map((card, index) => {
          return (
            <Grid
              key={`learning-resources-item-${index}`}
              item
              xs
              h-100={+true}
            >
              <Card style={{ height: '100%', width: '100%' }}>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h4"
                    style={{
                      padding: '3px 12px 3px 12px',
                    }}
                    component="div"
                  >
                    {card.title}
                  </Typography>
                  <Divider />
                  <List component="ul">
                    {card.links?.map((link, link_index) => {
                      return (
                        <ListItem key={link_index} divider>
                          <ListItemText
                            primary={
                              <Link
                                to={link.uri}
                                style={{ color: theme.palette.link }}
                              >
                                {link.resourceName}
                              </Link>
                            }
                            primaryTypographyProps={{
                              style: {
                                fontWeight: 700,
                              },
                            }}
                            secondary={link.description}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      <Typography
        align="center"
        style={{ width: '100%', padding: '40px 50px 40px 50px' }}
      >
        <PdsButton type="submit" onPdsButtonClick={handleOnClick}>
          Read more in the Engineering Handbook
        </PdsButton>
      </Typography>
    </div>
  );
}
